// External libraries
import React, { Component } from 'react'

export default class LocationImage extends Component {
  renderTextOverlay() {
    return (
      <div className="text-overlay">
        { this.props.children }
      </div>
    );
  }

  render() {
    let imgURL;
    if (!this.props.location || !this.props.location.getDisplayImage) { return null; }

    switch (this.props.type) {
      case 'thumbnail':
        imgURL = this.props.location.getSearchThumbnail();
        break;
      case 'gallery':
        imgURL = this.props.location.getDisplayImage();
        break;
      default:
        imgURL = this.props.location.getDisplayImage();
        break;
    }

    const backgroundImageStyle = imgURL ? { backgroundImage: `url('${imgURL}')` } : null;
    return (
      <div>
        <div className='location-image' style={backgroundImageStyle} >
          { this.props.children ? this.renderTextOverlay() : null }
        </div>
        <img src={imgURL} className="visible-print-block" alt="" />
      </div>
    );
  }
}
